import { useMemo } from 'react';

import { useClientController_AllLiceDailyReport } from '@/services/hooks';
import type { DailyReportResult } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapDailyReportResultToDomain } from './mappers';
import type { UseGetLocationDailyLiceReportResult } from './types';

export const useGetLocationDailyLiceReport = (
    clientId: number,
    locationId: number,
    day: string,
    options?: DomainQueryOptions<DailyReportResult>
): UseGetLocationDailyLiceReportResult => {
    const query = useClientController_AllLiceDailyReport(clientId, { locationId, day }, options);

    const dailyReport = useMemo(() => {
        if (!query.data?.data) return null;
        return mapDailyReportResultToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: dailyReport,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
